import { Dropdown } from '../../../components/ui';

interface IncomeStepProps {
  monthlyIncome: string;
  onChange: (income: string) => void;
}

const INCOME_OPTIONS = [
  { value: 'under3k', label: 'Under $3,000' },
  { value: '3k-5k', label: '$3,000 - $5,000' },
  { value: '5k-8k', label: '$5,000 - $8,000' },
  { value: '8k-12k', label: '$8,000 - $12,000' },
  { value: '12k-20k', label: '$12,000 - $20,000' },
  { value: 'over20k', label: 'Over $20,000' },
];

export default function IncomeStep({ monthlyIncome, onChange }: IncomeStepProps) {
  return (
    <div className="quiz-step">
      <div className="quiz-step__header">
        <h2 className="quiz-step__question">What's your monthly take-home income?</h2>
        <p className="quiz-step__helper">After taxes - we'll use this to build your plan</p>
      </div>

      <div className="quiz-step__body">
        <Dropdown
          placeholder="Select income range"
          value={monthlyIncome}
          onChange={onChange}
          options={INCOME_OPTIONS}
          size="lg"
        />
      </div>
    </div>
  );
}
